import { Message } from 'element-ui';
import i18n from '@/plugins/i18n.plugin';

/** Figma 轻提示：展示 3s，淡出 300ms；可点 X 关闭；重复触发只重置计时 */
const EMP_LIGHT_TOAST_DURATION_MS = 3000;
const EMP_LIGHT_TOAST_CLASS = 'emp-draft-save-toast';

let activeLightToast = null;
let lightToastTimer = null;

function clearLightToastTimer() {
  if (lightToastTimer) {
    clearTimeout(lightToastTimer);
    lightToastTimer = null;
  }
}

function dismissActiveLightToast(instant = false) {
  clearLightToastTimer();
  const inst = activeLightToast;
  activeLightToast = null;
  if (!inst) return;
  try {
    if (instant && inst.$el && inst.$el.parentNode) {
      inst.$el.parentNode.removeChild(inst.$el);
      if (typeof inst.$destroy === 'function') inst.$destroy();
      return;
    }
    if (typeof inst.close === 'function') inst.close();
  } catch (e) {
    /* ignore */
  }
}

/**
 * 成功轻提示（单例）
 * - 3 秒后自动淡出（可点 X 关闭）
 * - 再次调用：立刻替换并重新计时，不叠加
 * @param {string} [message]
 */
export function showEmpSuccessToast(message) {
  const text = message
    || (i18n && typeof i18n.t === 'function' ? i18n.t('lbl_EMPBE_Oprate_Scuessfully') : 'Draft saved successfully');

  if (activeLightToast) {
    dismissActiveLightToast(true);
  }

  activeLightToast = Message({
    message: text,
    type: 'success',
    duration: 0,
    showClose: true,
    customClass: EMP_LIGHT_TOAST_CLASS,
    onClose: () => {
      clearLightToastTimer();
      activeLightToast = null;
    },
  });

  lightToastTimer = setTimeout(() => {
    lightToastTimer = null;
    const inst = activeLightToast;
    activeLightToast = null;
    if (inst && typeof inst.close === 'function') {
      inst.close();
    }
  }, EMP_LIGHT_TOAST_DURATION_MS);

  return activeLightToast;
}

/** @deprecated 使用 showEmpSuccessToast；保留别名兼容草稿保存调用 */
export function showDraftSaveSuccessToast(message) {
  return showEmpSuccessToast(message);
}

export default {
  install(Vue) {
    Vue.prototype.$showEmpSuccessToast = showEmpSuccessToast;
    Vue.prototype.$showDraftSaveSuccessToast = showDraftSaveSuccessToast;
  },
};
